// Direct API access – no local proxy server needed.
// Capacitor native apps are not subject to CORS restrictions,
// so we can call Yahoo Finance & CoinGecko directly.

export const YAHOO_BASE = 'https://query2.finance.yahoo.com';
export const COINGECKO_BASE = 'https://api.coingecko.com/api/v3';

// Remote server (Hetzner) – used by both browser dev and native builds
const DEFAULT_API = 'https://api.bullivo.de';
export const PROXY_BASE = process.env.REACT_APP_API_BASE_URL || DEFAULT_API;

// Detect if running inside Capacitor (native app) – checked at call time, not import time
export function isNative() {
  return typeof window !== 'undefined' &&
    window.Capacitor?.isNativePlatform?.() === true;
}

// Immer über den Server – dort läuft News-Sentiment, Caching, etc.
export function shouldUseDirectApi() {
  return false;
}
